export const STORE_KEYS = {
	USER_TOKEN: 'USER_TOKEN',
	CONFIGURED: 'CONFIGURED',
	USER_NAME: 'user_name',
	USER_ID_INFO: 'USER_ID_INFO',
};

class Storage {
	get = (key: string) => {
		let data: any = localStorage.getItem(key);
		try {
			data = JSON.parse(data);
			return data;
		} catch (error) {
			return data;
		}
	};
	set = (key: string, value: any) => {
		return localStorage.setItem(key, typeof value === 'object' ? JSON.stringify(value) : value);
	};
	remove = (key: string) => {
		return localStorage.setItem(key, '');
	};
	clear = () => localStorage.clear();
}

export default new Storage();
